<form [formGroup]="formName">
    @if (field.name && field.options) {
        <mat-label>
            {{ field.label }}
            @if (isFieldRequired(field)) {
                <span>*</span>
            }
        </mat-label>
        @for (option of field.options; let optionIndex = $index; track optionIndex) {
            <mat-checkbox
                class="mat-small w-100"
                color="primary"
                (change)="selectOption(option.value, $event.checked)"
                [checked]="values.includes(option.value)"
            >
                {{ option.displayValue }}
            </mat-checkbox>
        }
    }
</form>
